import { useContext, useEffect } from 'react';

import { ReactReduxContext } from 'react-redux'

import getInjectors from './sagaInjectors'

const useInjectSaga = ({
  key,
  saga,
  mode,
}: {
  key: string
  saga: any
  mode?: any
}) => {
  const context = useContext(ReactReduxContext)

  useEffect(() => {
    const injectors = getInjectors(context.store)
    injectors.injectSaga(key, { saga, mode })

    return () => {
      injectors.ejectSaga(key)
    }
  }, [])
}

export { useInjectSaga }
